import { cx } from '@linaria/core';
import { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { Button } from '@ui/kit';
import { useToggleState, CSSRefTransition } from '@utils/react';
import { useCourseBuilder, courseBuilderStore } from '../../../../state/store.js';
import { CreateCourseDrawer } from '../create-drawer/_create-drawer.js';
import { Onboarding } from '../onboarding/_onboarding.js';
import { showOnboardingOnMount } from '../onboarding/_onboarding.utils.js';
import { wrapperCls, headingCls, transitionCls, transitionDurationMs, scrollGradientCls, buttonWrapperCls, buttonCls, plusCls } from './_overview.style.js';
import { CourseList } from './course-list.js';
import { Empty } from './empty.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useGetAllCoursesQuery } from '../../../../api/query.get-all.js';

function Overview() {
  const [showOnboarding, onboardingActions] = useToggleState(showOnboardingOnMount());
  const {
    data
  } = useGetAllCoursesQuery();
  const showCreateDrawer = useCourseBuilder(state => state.showCreateDrawer);
  const rootRef = useRef(null);
  return /*#__PURE__*/jsxs("section", {
    ref: rootRef,
    className: cx(wrapperCls, data?.length && "withCourses"),
    children: [/*#__PURE__*/jsx("h1", {
      className: headingCls,
      children: "Mine forl\xF8b"
    }), /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: !data?.length ? /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: transitionCls,
        timeout: {
          enter: transitionDurationMs,
          exit: 0
        },
        children: ref => /*#__PURE__*/jsx(Empty, {
          ref: ref,
          toOnboarding: onboardingActions.enable
        })
      }, "empty") : /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: transitionCls,
        timeout: {
          enter: transitionDurationMs,
          exit: 0
        },
        children: ref => /*#__PURE__*/jsx(CourseList, {
          ref: ref,
          courses: data
        })
      }, "list")
    }), /*#__PURE__*/jsx("div", {
      className: scrollGradientCls
    }), /*#__PURE__*/jsx("div", {
      className: buttonWrapperCls,
      children: /*#__PURE__*/jsx(Button, {
        theme: "primary",
        className: buttonCls,
        onClick: () => {
          courseBuilderStore.dispatch(courseBuilderStore.actions.toggleCreateDrawer(true));
        },
        icon: /*#__PURE__*/jsx("span", {
          className: plusCls
        }),
        children: "Opret nyt forl\xF8b"
      })
    }), /*#__PURE__*/jsx(CreateCourseDrawer, {
      wrapperRef: rootRef,
      active: showCreateDrawer,
      onClose: () => {
        courseBuilderStore.dispatch(courseBuilderStore.actions.toggleCreateDrawer(false));
      }
    }), /*#__PURE__*/jsx(Onboarding, {
      active: showOnboarding,
      onCompleted: onboardingActions.disable
    })]
  });
}

export { Overview };
//# sourceMappingURL=_overview.js.map
